import { Alert } from '@zillow/constellation-10';

type MultiplexWarningBannerProps = {
  isInBuildingGroup?: boolean;
};

const MultiplexWarningBanner = ({ isInBuildingGroup = false }: MultiplexWarningBannerProps) => {
  if (!isInBuildingGroup) {
    return null;
  }

  return (
    <Alert tone="warning" css={{ marginBottom: '600' }}>
      This building already has a listing on Zillow. Your premium upgrade will appear within that building page —
      visibility may be lower than a standalone listing.
    </Alert>
  );
};

export default MultiplexWarningBanner;
